import React, {useCallback, useRef, useEffect} from "react";
import classNames from "classnames";
import {osName} from "react-device-detect";
import {Scrollbars} from "react-custom-scrollbars";
import {useDispatch, useSelector} from "react-redux";
import {isMobileOnly} from "react-device-detect";
import ReactGA from 'react-ga';

import Localization from "./common/Localization";
import {setHeaderLine, setId, finishMenuMove} from "./module/ScrollModule";

import UpperHeader from './component/UpperHeader';
import Header from './component/Header';
import MobileHeader from './component/MobileHeader';
import TopIntro from './component/TopIntro';
import AboutSponsored from './component/AboutSponsored';
import WhyMinimap from './component/WhyMinimap';
import UserStat from './component/UserStat';
import Price from './component/Price';
import Process from './component/Process';
import FAQ from './component/FAQ';
import Footer from './component/Footer';

import './common/index.scss';

const App = () => {
	Localization.setLanguage("kr");

	ReactGA.initialize("UA-78049152-11");
	ReactGA.set({page:"/partner"});
	ReactGA.pageview("/partner");
	
	const dispatch = useDispatch();
	const sectionElementList = useRef();

	const onUpdateScroll = useCallback((event) => {
		if(sectionElementList.current == null) {
			sectionElementList.current = document.getElementsByClassName("view_section");
		}

		const height = window.innerHeight;
		const top = event.scrollTop;
		const bottom = top + height;
		let index = -1;
		let maxPercent = 0;
		for(let i = 0 ; i < sectionElementList.current.length ; i++) {
			const section = sectionElementList.current[i];
			if(section.offsetTop + section.offsetHeight < top || section.offsetTop > bottom) {
				continue;
			}

			const viewTop = Math.max(top, section.offsetTop);
			const viewBottom = Math.min(bottom, section.offsetTop + section.offsetHeight);

			const percent = (viewBottom - viewTop) / Math.min(section.offsetHeight, height/3);
			
			if(percent > maxPercent) {
				index = i;
				maxPercent = percent;
			}
		}

		if(index > -1) {
			dispatch(setId(sectionElementList.current[index].id));
		}		
		if(top >= 100 && !isMobileOnly) {
			dispatch(setHeaderLine(true));
		} else if(top >= 60 && isMobileOnly) {
			dispatch(setHeaderLine(true));
		} else {
			dispatch(setHeaderLine(false));
		}
	}, [dispatch]);

	const moveToId = useSelector(state => state.ScrollModule.moveToId);
	const scrollbar = useRef();
	const moveTimer = useRef();
	useEffect(() => {
		if(moveToId !== "") {
			if(moveTimer.current > -1) {
				clearInterval(moveTimer.current);
			}

			let targetElement = null;
			for(let i = 0 ; i < sectionElementList.current.length ; i++) {
				const section = sectionElementList.current[i];
				if(section.id === moveToId) {
					targetElement = section;
					break;
				}
			}			
			
			if(targetElement != null) {
				let finalScrollTop = targetElement.offsetTop - (isMobileOnly ? -10 : 48);
				
				if(finalScrollTop > scrollbar.current.getScrollHeight() - scrollbar.current.getClientHeight()) {
					finalScrollTop = scrollbar.current.getScrollHeight() - scrollbar.current.getClientHeight();
				}

				let cnt = 0;
				moveTimer.current = setInterval(() => {
					cnt++;
					const beforeTop = scrollbar.current.getScrollTop();
					const interval = cnt >= 15 ? finalScrollTop - beforeTop : (finalScrollTop - beforeTop) / 3;
					
					scrollbar.current.scrollTop(scrollbar.current.getScrollTop() + interval);
					const afterTop = scrollbar.current.getScrollTop();
					let isFinish = false;
					if(afterTop <= 0 || afterTop >= scrollbar.current.getScrollHeight() - scrollbar.current.getClientHeight()) {
						isFinish = true;
					}
					if((interval > 0 && afterTop >= finalScrollTop) || (interval <= 0 && afterTop <= finalScrollTop)) {
						isFinish = true;
					}
					if(isFinish) {
						clearInterval(moveTimer.current);
						dispatch(finishMenuMove());
						moveTimer.current = -1;
					}
				}, 24);
			}
		}
	}, [dispatch, moveToId]);

  return (
    <div id="rootWrapper" className={classNames(osName === "Windows" ? "os-window" : "", isMobileOnly ? "mobile_layout" : "")}>
			<Scrollbars onUpdate={onUpdateScroll} ref={scrollbar}>
				{!isMobileOnly && <UpperHeader/>}
				{!isMobileOnly && <Header/>}
				{isMobileOnly && <MobileHeader/>}
				<TopIntro/>
				<AboutSponsored/>
				<WhyMinimap/>
				<UserStat/>
				<Price/>
				<Process/>
				<FAQ/>
				<Footer/>
			</Scrollbars>
    </div>
  )
} 


export default App;
